function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Icon / Small Unchecked Checkbox");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "path-1",
  x: 0,
  y: 0,
  width: 14,
  height: 14,
  rx: 2
}), /*#__PURE__*/React.createElement("filter", {
  x: "-7.1%",
  y: "-7.1%",
  width: "114.3%",
  height: "114.3%",
  filterUnits: "objectBoundingBox",
  id: "filter-2"
}, /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 0.5,
  in: "SourceAlpha",
  result: "shadowBlurInner1"
}), /*#__PURE__*/React.createElement("feOffset", {
  dx: 0,
  dy: 1,
  in: "shadowBlurInner1",
  result: "shadowOffsetInner1"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "shadowOffsetInner1",
  in2: "SourceAlpha",
  operator: "arithmetic",
  k2: -1,
  k3: 1,
  result: "shadowInnerInner1"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
  type: "matrix",
  in: "shadowInnerInner1"
})));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Icon-/-Small-Unchecked-Checkbox",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "checkbox-copy-10"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#FFFFFF",
  fillRule: "evenodd",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("use", {
  fill: "black",
  fillOpacity: 1,
  filter: "url(#filter-2)",
  xlinkHref: "#path-1"
}), /*#__PURE__*/React.createElement("rect", {
  stroke: "#CCCCCC",
  strokeWidth: 1,
  strokeLinejoin: "square",
  x: 0.5,
  y: 0.5,
  width: 13,
  height: 13,
  rx: 2
})));

var SvgSmallUncheckedCheckbox = function SvgSmallUncheckedCheckbox(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSmallUncheckedCheckbox, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Small-Unchecked-Checkbox.e1511ce8.svg";
export { ForwardRef as ReactComponent };